import React from 'react';
import CusItemTooltip from './CusItemTooltip';
import CusButton from './CusButton';
import { IconRefresh } from '@tabler/icons-react';
import useColor from '../../hooks/site/useColor';

export default function IconGenItem({ onGenerate, tooltipText = 'Generate' }) {
  const { primary } = useColor();

  return (
    <CusItemTooltip
      text={tooltipText}
      elem={
        <CusButton
          boxProps={{
            sx: {
              '&:hover svg': {
                stroke: primary.light,
                transform: 'rotate(180deg)',
                transition: 'transform 0.3s ease'
              }
            }
          }}
          onClick={onGenerate}>
          <IconRefresh color={primary.main} />
        </CusButton>
      }
    />
  );
}
